import { isNumeric } from '../../../../js/app/react/validators';

const shouldSkip = (isGoingForward, averageSpent) => isGoingForward && isNumeric(averageSpent);

export default shouldSkip;
